import React from 'react';
import { ChatInterface } from '../../stateless/common/chatInterface';
import './styles.less';

const ChatPage: React.FC = () => {
	return (
		<div className="chat-page">
			<div className="chat-interface-container">
				<ChatInterface isOpen={true} onClose={() => {}} />
			</div>
		</div>
	);
};

export default ChatPage;
